module.exports = __webpack_public_path__ + "media/applicants/shopper-safety-mobile-ea121d93.jpg";